<template>
    <v-carousel
    hide-delimiters 
    height="500" 
    v-bind:class="{ [`elevation-${selected}`]: true }">
            <v-carousel-item
                v-for="(item,i) in items"
                :key="i"
                :src="item.src"
            ></v-carousel-item>
    </v-carousel>
</template>

<script>
export default {
     data: () => ({
      
            items: [
        {
          src: require('../assets/chanta/chanta (1).jpg')
        },
        {
          src: require('../assets/chanta/chanta (2).jpg')
        },
        {
          src: require('../assets/chanta/chanta (3).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (4).jpg')
        },
        {
          src: require('../assets/chanta/chanta (5).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (6).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (7).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (8).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (9).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (10).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (11).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (12).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (13).jpg')
        },
        {
          src: require('../assets/chanta/chanta (14).jpg')
        },
        {
          src: require('../assets/chanta/chanta (15).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (16).jpg')
        },
        {
          src: require('../assets/chanta/chanta (17).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (18).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (19).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (20).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (21).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (22).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (23).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (24).jpg')       
        },
        {
          src: require('../assets/chanta/chanta (25).jpg')       
        },
      ],
      selected: 24
     })
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/chanta.vue